import React, { Children, isValidElement } from 'react';
import { SplitActionProps } from './SplitAction.types';
import { SplitActionContext } from './SplitActionContext';
import { st, classes } from './SplitAction.st.css';
import { Divider } from '../Divider';

export const SplitAction = (props: SplitActionProps) => {
  const { children, className, dataHook, skin, priority, size, disabled } =
    props;

  const sharedProps = { skin, priority, size, disabled };

  return (
    <div className={st(classes.root, { size }, className)} data-hook={dataHook}>
      {Children.map(children, (child, index) => {
        if (!isValidElement(child)) {
          return child;
        }
        return (
          <SplitActionContext.Provider
            value={{
              ...sharedProps,
            }}
          >
            {index > 0 && (
              <Divider
                direction="vertical"
                className={st(classes.divider)}
                skin={
                  sharedProps.priority === 'secondary' && !sharedProps.skin
                    ? 'standard'
                    : sharedProps.skin === 'inverted'
                      ? 'standard'
                      : sharedProps.skin === 'transparent'
                        ? 'light'
                        : sharedProps.skin
                }
              />
            )}
            <div className={classes.item}>{child}</div>
          </SplitActionContext.Provider>
        );
      })}
    </div>
  );
};

SplitAction.displayName = 'SplitAction';
